export default __webpack_public_path__ + "static/media/az4.020cf511.jpeg";